import {CreateWhatsappIntentsUserError} from '../Errors/CreateWhatsappIntentsUserError.js'

export class CreateWhatsappIntentsUserRequest {
  #resourceType
  #resourceId

  constructor({resourceType, resourceId}) {
    this.#resourceType = resourceType
    this.#resourceId = resourceId
  }

  static validate({resourceId}) {
    if (!resourceId || typeof resourceId !== 'string') {
      throw CreateWhatsappIntentsUserError.create({
        message: '[CreateWhatsappIntentsUserRequest.validate] resourceId is required and must be a string'
      })
    }
  }

  static create = ({resourceType = 'AD', resourceId}) => {
    CreateWhatsappIntentsUserRequest.validate({resourceId})

    return new CreateWhatsappIntentsUserRequest({resourceType, resourceId})
  }

  toJSON() {
    return {
      resourceType: this.#resourceType,
      resourceId: this.#resourceId
    }
  }
}

export const factory = CreateWhatsappIntentsUserRequest.create
